<template>
  <div>
    <v-container grid-list-md text-xs-center>
      <v-layout row align-center wrap>
        <v-flex xs12>
          <v-toolbar dark color="primary">
            <v-toolbar-title>通路：</v-toolbar-title>
            <v-autocomplete
              v-model="selectAgentId"
              :loading="loading"
              :items="agentItems"
              :search-input.sync="searchAgent"
              cache-items
              class="mx-4"
              flat
              hide-no-data
              hide-details
              label="通路名稱"
              solo-inverted
              item-text="displayName"
              item-value="agentId"
            ></v-autocomplete>
          </v-toolbar>
        </v-flex>
          <v-flex xs5 sm5 md5>
            <date-picker :date.sync="postData.startDate"/>
          </v-flex>
          <v-flex xs5 sm5 md5>
            <date-picker :date.sync="postData.endDate"/>
          </v-flex>
          <v-flex xs2 sm2 md2>
            <v-btn class="primary" :loading="loading" dark text @click="searchAction">確定</v-btn>
          </v-flex>
      </v-layout>
      <v-layout row wrap >
        <v-tabs v-model="tab">
          <v-tab :key="0" @change="tab=0">比較圖</v-tab>
          <v-tab :key="1" @change="tab=1">長條圖</v-tab>
        </v-tabs>
      </v-layout>
      <div v-if="tab === 0">
        <v-layout row wrap >
          <v-flex xs12 lg6 >
            <h2>原融/商品貸進件數 ({{ totalCount }} 件)</h2>
            <div v-if="chartData.labels">
              <span style="font-size: 16px; font-weight: bold;">{{ chartData.labels[0] }}</span><br/>
              <span style="font-size: 16px; font-weight: bold;">{{ chartData.labels[1] }}</span>
            </div>
            <pie-chart :chart-data="chartData"></pie-chart>
          </v-flex >
          <v-flex xs12 lg6>
            <h2>原融/商品貸-總核准 ({{ totalApprovedCount }}件 / {{ totalApprovedRate}}%)</h2>
            <div v-if="chartData1.labels">
              <span style="font-size: 16px; font-weight: bold;">{{ chartData1.labels[0] }}</span><br/>
              <span style="font-size: 16px; font-weight: bold;">{{ chartData1.labels[1] }}</span>
            </div>
            <pie-chart :chart-data="chartData1"></pie-chart>
          </v-flex >
        </v-layout>
        <br/><br/>
        <hr/>
        <br/><br/>
        <v-layout row wrap mt2>
          <v-flex xs12 lg6>
            <h2>原融/商品貸-核准率 ({{ totalApprovedRateCount }}件 / {{ approvedRate}}%)</h2>
            <div v-if="chartData2.labels">
              <span style="font-size: 16px; font-weight: bold;">{{ chartData2.labels[0] }}</span><br/>
              <span style="font-size: 16px; font-weight: bold;">{{ chartData2.labels[1] }}</span>
            </div>
            <pie-chart :chart-data="chartData2"></pie-chart>
          </v-flex >
          <v-flex xs12 lg6>
            <h2>原融/商品貸-申覆核准率 ({{ totalApprovedExamRateCount }}件 / {{ approvedExamRate}}%)</h2>
            <div v-if="chartData3.labels">
              <span style="font-size: 16px; font-weight: bold;">{{ chartData3.labels[0] }}</span><br/>
              <span style="font-size: 16px; font-weight: bold;">{{ chartData3.labels[1] }}</span>
            </div>
            <pie-chart :chart-data="chartData3"></pie-chart>
          </v-flex >
        </v-layout>
        <br/><br/>
        <hr/>
        <br/><br/>
        <v-layout row wrap mt2>
          <v-flex xs12 lg6>
            <h2>原融/商品貸-已撥款數  ({{ totalPayCount }} 件)</h2>
            <div v-if="chartData4.labels">
              <span style="font-size: 16px; font-weight: bold;">{{ chartData4.labels[0] }}</span><br/>
              <span style="font-size: 16px; font-weight: bold;">{{ chartData4.labels[1] }}</span><br/>
              <span style="font-size: 16px; font-weight: bold;">核准且撥款 {{ currentRangeCount }}件</span>
            </div>
            <pie-chart :chart-data="chartData4"></pie-chart>
          </v-flex >
        </v-layout>
      </div>
      <div v-if="tab === 1">
        <v-layout row wrap>
          <v-flex xs12 md12>
            <h2>進件件數 & 核准件數</h2>
            <bar-chart :styles="lineChartStyles" :chart-data="yearChartData"></bar-chart>
            <!--          <line-chart :styles="lineChartStyles" :chart-data="yearChartData"></line-chart>-->
          </v-flex>
        </v-layout>
        <v-layout v-if="yearChartData.datasets">
          <v-flex>
            <table border="1">
              <thead>
                <tr>
                  <td>
                    <span :style="{fontSize: '16px', fontWeight: 'bold'}">月份</span>
                  </td>
                  <td v-for="(text, i) of yearChartData.labels" :key="`table_key_${i}`">
                     <span :style="{fontSize: '16px', fontWeight: 'bold'}">
                    {{text}}
                  </span>
                  </td>
                </tr>
              </thead>
              <tbody>
              <tr v-for="(tableData, i) of yearTableData" :key="`table_${i}`">
                <td v-for="(value, j) of tableData" :key="`table_value_${i}_${j}`">
                  <span :style="{color: i < yearChartData.datasets.length ? yearChartData.datasets[i].backgroundColor : '#000', fontSize: '16px', fontWeight: 'bold'}">
                    {{value}}
                  </span>
                </td>
              </tr>
              </tbody>
            </table>
          </v-flex>
        </v-layout>
        <br/><br/>
        <hr/>
        <br/><br/>
        <v-layout row wrap>
          <v-flex xs12 md12>
            <h2>撥款件數 & 撥款金額(百萬)</h2>
            <bar-chart :styles="lineChartStyles" :chart-data="yearChartData1"></bar-chart>
          </v-flex>
        </v-layout>
        <v-layout v-if="yearChartData1.datasets">
          <v-flex>
            <table border="1">
              <thead>
              <tr>
                <td>
                  <span :style="{fontSize: '16px', fontWeight: 'bold'}">月份</span>
                </td>
                <td v-for="(text, i) of yearChartData1.labels" :key="`table_key1_${i}`">
                   <span :style="{fontSize: '16px', fontWeight: 'bold'}">
                    {{text}}
                  </span>
                </td>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(tableData, i) of yearTableData1" :key="`table1_${i}`">
                <td v-for="(value, j) of tableData" :key="`table_value1_${i}_${j}`">
                  <span :style="{color: i < yearChartData1.datasets.length ? yearChartData1.datasets[i].backgroundColor : '#000'
                  , fontSize: '16px', fontWeight: 'bold'}">
                    {{value}}
                  </span>
                </td>
              </tr>
              </tbody>
            </table>
          </v-flex>
        </v-layout>
        <br/><br/>
        <hr/>
        <br/><br/>
        <v-layout row wrap>
          <v-flex xs12 md12>
            <h2>附條件件數 & 已核未撥</h2>
            <bar-chart :styles="lineChartStyles" :chart-data="yearChartData2"></bar-chart>
          </v-flex>
        </v-layout>
        <v-layout v-if="yearChartData2.datasets">
          <v-flex>
            <table border="1">
              <thead>
              <tr>
                <td>
                  <span :style="{fontSize: '16px', fontWeight: 'bold'}">月份</span>
                </td>
                <td v-for="(text, i) of yearChartData2.labels" :key="`table_key2_${i}`">
                  <span :style="{fontSize: '16px', fontWeight: 'bold'}">
                    {{text}}
                  </span>
                </td>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(tableData, i) of yearTableData2" :key="`table2_${i}`">
                <td v-for="(value, j) of tableData" :key="`tv2_${i}_${j}`">
                  <span :style="{color: i < yearChartData2.datasets.length ? yearChartData2.datasets[i].backgroundColor : '#000'
                  , fontSize: '16px', fontWeight: 'bold'}">
                    {{value}}
                  </span>
                </td>
              </tr>
              </tbody>
            </table>
          </v-flex>
        </v-layout>
      </div>
    </v-container>
  </div>
</template>

<script>
import { vueChart } from "vue-chartjs";
import { mapActions, mapGetters } from 'vuex';
import LineChart from "../utils/lineChart";
import BarChart from "../utils/barChart";
import PieChart from "../utils/pieChart";
import DatePicker from "../../components/DatePicker";
import { getYearApprovedInfo } from '@/store/actions';

export default {
  components: {
    LineChart,
    BarChart,
    PieChart,
    DatePicker,
  },
  data() {
    return {
      tab: 0,
      totalCount: 0,
      totalApprovedCount: 0,
      totalApprovedRateCount: 0,
      totalApprovedExamRateCount: 0,
      totalApprovedRate: 0,
      approvedRate: 0,
      approvedExamRate: 0,
      totalPayCount: 0,
      currentRangeCount: 0,
      selectAgentId: null,
      searchAgent: null,
      agentItems: [],
      loading: false,
      height: 400,
      feedQuantityList: null,
      approvalRateList: {
        labels: [],
        datasets: []
      },
      maleFemaleRatioList: {
          labels: [],
          datasets: []
        },
      localDistributionList: null,
      performanceList:  {
          labels: [],
          datasets: []
      },
      postData:{
        agentId:'',
        startDate: '',
        endDate: '',
      },
      chartArray: [
        {
          key: "feedQuantity",
          title: "當月進件量",
          datasets: []
        },
        {
          key: "approvalRate",
          title: "核準率",
          datasets: []
        },
        {
          key: "maleFemaleRatio",
          title: "男女比率",
          datasets: []
        },
        {
          key: "localDistribution",
          title: "地區分佈",
          datasets: []
        }
      ],
      chartData: {},
      chartData1: {},
      chartData2: {},
      chartData3: {},
      chartData4: {},
      yearChartData: {},
      yearTableData: [],
      yearChartData1: {},
      yearTableData1: [],
      yearChartData2: {},
      yearTableData2: [],
    };
  },
  created() {
    this.setDefaultDate();
    this.searchAction();
    this.fetchAgentList();
  },
  watch: {
    searchAgent(val) {
      this.querySelections(val);
    },
    tab(value){
      console.log(`change tab = ${value} || ${value === '1'} | ${value === 1}`);
      if (value === 1){
        this.setYearDefaultDate();
      } else{
        this.setDefaultDate();
      }
      this.searchAction();
    }
  },
  computed: {
    ...mapGetters(['getAgentList']),
    agentList(){
      return this.getAgentList
    },
    lineChartStyles() {
      return {
        height: `${this.height}px`,
        position: "relative"
      };
    }
  },
  methods: {
    ...mapActions(['getGenderInfo','getApprovedInfo','getYearApprovedInfo','getBonusInfo', 'fetchAgentList']),
    querySelections(v) {
      this.loading = true;
      this.agentItems = this.agentList.filter((e) => {
        return (
          (e.displayName || "").toLowerCase().indexOf((v || "").toLowerCase()) >
          -1
        );
      });
      console.log(`agentItems == ${this.agentItems.length}`)
      this.loading = false;
    },
    setDefaultDate(){
      let date = new Date();
      //将当前月份加1，下移到下一个月
      date.setMonth(date.getMonth() + 1);
      //将当前的日期置为0，
      date.setDate(0);
      //再获取天数即取上个月的最后一天的天数
      let days = date.getDate();
      let currentDate = new Date().toISOString().substr(0, 10);
      const [year, month, day] = currentDate.split("-");
      this.postData.startDate = `${year}-${month}-01`;
      this.postData.endDate = `${year}-${month}-${days}`;
    },
    setYearDefaultDate(){
      let date = new Date();
      let days = date.getDate();
      let currentDate = new Date().toISOString().substr(0, 10);
      const [year, month, day] = currentDate.split("-");
      this.postData.startDate = `${year}-01-01`;
      this.postData.endDate = `${year}-${month}-${days}`;
      console.log(`setYearDefaultDate == ${JSON.stringify(this.postData)}`);
      this.$forceUpdate();
    },
    searchAction() {
      const startDate = `${this.postData.startDate} 00:00:00`;
      const endDate = `${this.postData.endDate} 23:59:59`;
      // this.feedQuantity();
      if (this.tab === 0){
        this.approvalRate(this.selectAgentId == null ? '' :this.selectAgentId, startDate, endDate);
      } else {
        this.loadYearAnalyticsData(this.selectAgentId == null ? '' :this.selectAgentId, startDate, endDate);
      }

      // this.maleFemaleRatio('', startDate, endDate);
      // this.localDistribution();
      // this.performance('', startDate, endDate);
    },
    feedQuantity() {
      let date = new Date();
      //将当前月份加1，下移到下一个月
      date.setMonth(date.getMonth() + 1);
      //将当前的日期置为0，
      date.setDate(0);
      //再获取天数即取上个月的最后一天的天数
      let days = date.getDate();
      const labelArray = [];
      for (let i = 1; i <= days; i++) {
        labelArray.push(i);
      }
      const valueArray = [];
      for (let i = 1; i <= days; i++) {
        valueArray.push(this.getRandom(101));
      }
      this.feedQuantityList = {
        labels: labelArray,
        datasets: [
          {
            label: "當月進件量",
            borderColor: 'rgba(255,99,132,1)',
            backgroundColor: 'rgba(255, 99, 132, 0.2)',
            data: valueArray
          },
        ]
      };
    },
    getRandom(x) {
      return Math.floor(Math.random()*x);
    },
    async approvalRate(agentId, startDate, endDate) {
      const data = {agentId, startDate, endDate};
      this.loading = true;
      const result =  await this.getApprovedInfo(data);
      this.loading = false;
      const dataList = result.data.data;
      console.log(`approvalRate == ${JSON.stringify(dataList)}`)
      this.currentRangeCount = dataList.total.currentRangeCount;
      this.chartData = {
        labels: [
          `原融-總件數 (${dataList.finance.count})`,
          `商品貸-總件數 (${dataList.caFinance.count})`,
        ],
          datasets: [
          {
            label: '案件數',
            backgroundColor: ['#60C4C6', '#24BD21'],
            data: [dataList.finance.count, dataList.caFinance.count]
          }
        ]
      }
      this.totalCount = (dataList.finance.count + dataList.caFinance.count);

      this.chartData1 = {
        labels: [
          `原融-總核准率 ${dataList.total.totalApprovedCount}件 (${dataList.total.totalRate === null ? '0': dataList.total.totalRate}%)`,
          `商品貸-總核准率 ${dataList.total.totalCaApprovedCount}件 (${dataList.total.totalCARate === null ? '0': dataList.total.totalCARate}%)`,
        ],
        datasets: [
          {
            label: '總核准件數',
            backgroundColor: [ '#FF6042', '#EDCA4C'],
            data: [dataList.total.totalApprovedCount, dataList.total.totalCaApprovedCount]
          }
        ]
      }
      this.totalApprovedCount = (dataList.total.totalApprovedCount + dataList.total.totalCaApprovedCount)
      this.totalApprovedRate = Math.round(((parseInt(this.totalApprovedCount) / parseInt(this.totalCount)) + Number.EPSILON) * 100);

      this.chartData2 = {
        labels: [
          `原融-核准率 ${dataList.finance.approvedRate.approvedCount}件 (${dataList.finance.approvedRate.rateText === null ? '0': dataList.finance.approvedRate.rateText}%)`,
          `商品貸-核准率 ${dataList.caFinance.caApprovedRate.approvedCount}件 (${dataList.caFinance.caApprovedRate.rateText === null ? '0': dataList.caFinance.caApprovedRate.rateText}%)`,
        ],
        datasets: [
          {
            label: '核准率',
            backgroundColor: [ '#C8C7C7', '#DF6FC6'],
            data: [dataList.finance.approvedRate.approvedCount, dataList.caFinance.caApprovedRate.approvedCount]
          }
        ]
      }
      this.totalApprovedRateCount = (dataList.finance.approvedRate.approvedCount + dataList.caFinance.caApprovedRate.approvedCount);
      this.approvedRate = Math.round(((parseInt(this.totalApprovedRateCount) / parseInt(this.totalCount)) + Number.EPSILON) * 100);


      this.chartData3 = {
        labels: [
          `原融-申覆核准率 ${dataList.finance.approvedExamRate.approvedCount}件 (${dataList.finance.approvedExamRate.rateText === null ? '0': dataList.finance.approvedExamRate.rateText}%)`,
          `商品貸-申覆核准率 ${dataList.caFinance.caApprovedExamRate.approvedCount}件 (${dataList.caFinance.caApprovedExamRate.rateText === null ? '0': dataList.caFinance.caApprovedExamRate.rateText}%)`,
        ],
        datasets: [
          {
            label: '核准率',
            backgroundColor: ['#76D5D7' , '#355A7C'],
            data: [dataList.finance.approvedExamRate.approvedCount, dataList.caFinance.caApprovedExamRate.approvedCount]
          }
        ]
      }
      this.totalApprovedExamRateCount = (dataList.finance.approvedExamRate.approvedCount + dataList.caFinance.caApprovedExamRate.approvedCount);
      this.approvedExamRate = Math.round(((parseInt(this.totalApprovedExamRateCount) / parseInt(this.totalCount)) + Number.EPSILON) * 100);


      this.chartData4 = {
        labels: [
          `原融-已撥款數 ${dataList.pay.amountResults.count}件 ($${dataList.pay.amountResults.amount === null ? '0': dataList.pay.amountResults.amount})`,
          `商品貸-已撥款數 ${dataList.pay.caAmountResults.count}件 ($${dataList.pay.caAmountResults.amount === null ? '0': dataList.pay.caAmountResults.amount})`,
        ],
        datasets: [
          {
            label: '已撥款數',
            backgroundColor: ['#646667' , '#41B883'],
            data: [dataList.pay.amountResults.count, dataList.pay.caAmountResults.count]
          }
        ]
      }
      this.totalPayCount = (dataList.pay.amountResults.count + dataList.pay.caAmountResults.count)
    },
    async loadYearAnalyticsData(agentId, startDate, endDate){
      const query = {agentId, startDate, endDate};
      this.loading = true;
      const res =  await this.getYearApprovedInfo(query);
      this.loading = false;
      const result = res.data.data;
      const totalList = result.allResults;
      const dataList = result.approvedResults;
      const payList = result.payResults;
      const attachList = result.attachResults;
      console.log(`totalList == ${JSON.stringify(totalList)}`)
      console.log(`approvalRate == ${JSON.stringify(dataList)}`)
      console.log(`payList == ${JSON.stringify(payList)}`)
      console.log(`attachList == ${JSON.stringify(attachList)}`)
      const total = {
        data: [],
      }
      const attach = {
        data: [],
        approved: [],
      }
      let labels = [];
      let amount = [];
      let data = [];
      let rateList = ['核准率'];
      for (let item of totalList){
        total.data.push(item.count);
      }
      let i = 0;
      for (let item of dataList){
        labels.push(`${item.year}-${item.month}`);
        amount.push((item.amount / 1000000));
        data.push(item.count);
        rateList.push(`${Math.round((item.count / total.data[i]) * 100)}%`);
        const approved = item.count - payList[i].count;
        attach.approved.push(approved);
        i++;
      }


      const titleList = ['進件件數'];
      titleList.push(...total.data);

      const approvedDataList = ['核准件數'];
      approvedDataList.push(...data);
      this.yearTableData = [];
      this.yearTableData.push(titleList);
      this.yearTableData.push(approvedDataList);
      this.yearTableData.push(rateList);

      for (let item of attachList){
        attach.data.push(item.count);
      }
      this.yearChartData = {
        labels: labels,
        datasets: [
          {
            label: '進件件數',
            backgroundColor: 'rgba(255,99,132,1)',
            data: total.data,
            borderWidth: 1,
            categoryPercentage: 1,
          },
          {
            label: '核准件數',
            backgroundColor: 'rgba(54, 162, 235, 1)' ,
            data: data,
            borderWidth: 1,
          }
        ]
      }

      let payCount = [];
      let payAmountCount = [];
      for (let item of payList){
        payCount.push(item.count);
        payAmountCount.push(Math.round(item.amount * 10) / 10000000);
      }

      this.yearChartData1 = {
        labels: labels,
        datasets: [
          {
            label: '已撥款件數',
            backgroundColor: 'rgba(54, 162, 235, 1)' ,
            data: payCount
          },
          {
            label: '撥款金額(百萬)',
            backgroundColor: '#41B883',
            data: payAmountCount
          }
        ]
      }

      const titleList1 = ['已撥款件數'];
      titleList1.push(...payCount);

      const payDataList = ['撥款金額(百萬)'];
      payDataList.push(...payAmountCount);
      this.yearTableData1 = [];
      this.yearTableData1.push(titleList1);
      this.yearTableData1.push(payDataList);


      this.yearChartData2 = {
        labels: labels,
        datasets: [
          {
            label: '附條件件數',
            backgroundColor: '#FF6042',
            data: attach.data
          },
          {
            label: '已核未撥件數',
            backgroundColor: '#EDCA4C',
            data: attach.approved
          }
        ]
      }
      const titleList2 = ['附條件件數'];
      titleList2.push(...attach.data);

      const approvedList = ['已核未撥件數'];
      approvedList.push(...attach.approved);
      this.yearTableData2 = [];
      this.yearTableData2.push(titleList2);
      this.yearTableData2.push(approvedList);


    },
    async maleFemaleRatio(agentId, startDate, endDate) {
      const data = {agentId, startDate, endDate};
      const result =  await this.getGenderInfo(data);
      this.maleFemaleRatioList = {
          labels: ["女生人數", "男生人數"],
          datasets: [{
              borderWidth: 1,
              borderColor: [
              'rgba(255,99,132,1)',
              'rgba(54, 162, 235, 1)',
              ],
              backgroundColor: [
              'rgba(255, 99, 132, 0.2)',
              'rgba(54, 162, 235, 0.2)',
              ],
              data: [result.data.data.woman,	result.data.data.man]
            }]
        }
    },
    localDistribution() {
      const labelArray = ['基隆市','台北市','新北市','桃園縣','新竹市','新竹縣',
      '苗栗縣','台中市','彰化縣','南投縣','雲林縣','嘉義市',
      '嘉義縣','台南市','高雄市','屏東縣','台東縣','花蓮縣',
      '宜蘭縣','澎湖縣','金門縣','連江縣'];
      const valueArray = ['30','500','430','200','1000','230',
      '490','100','5','700','730','300',
      '368','550','690','910','340','880',
      '666','777','222','111']
      this.localDistributionList = {
        labels: labelArray,
        datasets: [
          {
            label: "地區分佈",
            borderColor: 'rgba(255,99,132,1)',
            backgroundColor: 'rgba(255, 99, 132, 0.2)',
            data: valueArray
          }
        ]
      };
    },
    async performance(agentId, startDate, endDate) {
      const data = {agentId, startDate, endDate};
      const result =  await this.getBonusInfo(data);
      const dataList = result.data.data.list;
      const labels = [];
      const totalArray = [];
      const bonusArray = [];

      Array.prototype.forEach.call(dataList, (element) => {
        // labels.push( element.applyDate);
        // totalArray.push( element.totalPrice);
        // bonusArray.push( element.bonus);
        const totalPrice = element.totalPrice / 1000;
        const bonus = element.bonus / 100;
        labels.push( element.applyDate);
        totalArray.push(totalPrice);
        bonusArray.push(bonus);
      });
      console.log(`${totalArray}  ${bonusArray}`);
      this.performanceList = {
        labels: labels,
        datasets: [
          {
            label: "當月業績(萬元)",
            borderColor: 'rgba(54, 162, 235, 1)',
            backgroundColor: 'rgba(54, 162, 235, 0.2)',
            data: totalArray
          },
          {
            label: "佣金(千元)",
            borderColor: 'rgba(255,99,132,1)',
            backgroundColor: 'rgba(255, 99, 132, 0.2)',
            data: bonusArray
          }
        ]
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/web/ReportChart.vue